var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/follow_dock.a682c193.png","uri@2x": __webpack_public_path__ + "static/media/follow_dock.bca17e07.png","uri@3x": __webpack_public_path__ + "static/media/follow_dock.da962634.png",
    width: 22,
    height: 16
});